import { useEffect, useRef } from 'react';

type Handler = (event: string, data: any) => void;

// Cloudflare deploy has no persistent SSE server, so we poll instead.
// Every tick we fire the same event names the components already refetch on,
// so live-ish updates keep working with no component changes. Name kept as
// `useSSE` so call sites are untouched.
const POLL_MS = 5000;

export function useSSE(onEvent: Handler, deps: any[] = []) {
  const handlerRef = useRef(onEvent);
  handlerRef.current = onEvent;

  useEffect(() => {
    const tick = () => {
      handlerRef.current('response', { poll: true });
      handlerRef.current('fixes', { poll: true });
    };
    const timer = setInterval(tick, POLL_MS);
    return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
